/** 
 * @type {ClustersFilter} 
 */ 
 const filter = { 
with: null, 
orderBy: null, 
ids: null, 
codes: null, 
names: null, 
} 
 /** 
 * @returns {ClustersFilter} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(filter)); 
 } 



// WEBPACK FOOTER //
// ./resources/js/filters/ClustersFilter.js